import { computed, getCurrentInstance } from 'vue'

export function useNavigator() {
  const { proxy } = getCurrentInstance()

  /**
   * Navega a una ruta por nombre con params y/o query
   * @param {string} name - nombre de la ruta definida en el router
   * @param {Object} params - parámetros dinámicos de la ruta
   * @param {Object} query - parámetros de consulta (opcional)
   * @param {boolean} replace - si true, usa replace en vez de push
   */
  const goTo = ({ name, params = {}, query = {}, replace = false }) => {
    if (!proxy || !proxy.$router) {
      console.error('Navigator: $router no está disponible en el contexto.')
      return
    }

    const route = { name, params, query }
    replace ? proxy.$router.replace(route) : proxy.$router.push(route)
  }

   /**
   * Devuelve un parámetro de la URL como computed
   * @param {string} key - nombre del parámetro en la ruta
   */
   const getParam = (key) => {
    return computed(() => {
      return proxy && proxy.$route && proxy.$route.params
        ? proxy.$route.params[key]
        : undefined
    })
  }

  return { goTo, getParam }
}
